/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './tx-display.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../app/shared/component/tx-display/tx-display.component';
import * as i3 from '@angular/common';
const styles_TxDisplayComponent:any[] = [i0.styles];
export const RenderType_TxDisplayComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TxDisplayComponent,data:{}});
function View_TxDisplayComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'a',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),
      0,'img',([] as any[]),[[1,'src',4]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  ']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.file.path;
    _ck(_v,2,0,currVal_0);
  });
}
function View_TxDisplayComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'video',[['controls',
      'controls'],['preload','metadata']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(2,0,(null as any),(null as any),0,'source',[['alt',''],['type',
          'video/mp4']],[[8,'src',4]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  ']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵinlineInterpolate(1,'',(_co.file.url || _co.file.path),
        '#t=0.5');
    _ck(_v,2,0,currVal_0);
  });
}
export function View_TxDisplayComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),7,'div',([] as any[]),
      (null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i2.TxDisplayComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.openFile()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TxDisplayComponent_1)),
      i1.ɵdid(3,16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TxDisplayComponent_2)),
      i1.ɵdid(6,16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i2.TxDisplayComponent = _v.component;
    const currVal_0:any = (_co.file.fileType === 'IMAGE');
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = (_co.file.fileType === 'VIDEO');
    _ck(_v,6,0,currVal_1);
  },(null as any));
}
export function View_TxDisplayComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'tx-display',
      ([] as any[]),(null as any),(null as any),(null as any),View_TxDisplayComponent_0,
      RenderType_TxDisplayComponent)),i1.ɵdid(1,114688,(null as any),0,i2.TxDisplayComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const TxDisplayComponentNgFactory:i1.ComponentFactory<i2.TxDisplayComponent> = i1.ɵccf('tx-display',
    i2.TxDisplayComponent,View_TxDisplayComponent_Host_0,{file:'file'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnQvdHgtZGlzcGxheS90eC1kaXNwbGF5LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL2plbmtpbnMvd29ya3NwYWNlL3Byb2R1Y3Rpb24tYXJnb3MtZnJvbnQvYXJnb3Mvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50L3R4LWRpc3BsYXkvdHgtZGlzcGxheS5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL2plbmtpbnMvd29ya3NwYWNlL3Byb2R1Y3Rpb24tYXJnb3MtZnJvbnQvYXJnb3Mvc3JjL2FwcC9zaGFyZWQvY29tcG9uZW50L3R4LWRpc3BsYXkvdHgtZGlzcGxheS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnQvdHgtZGlzcGxheS90eC1kaXNwbGF5LmNvbXBvbmVudC50cy5UeERpc3BsYXlDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IChjbGljayk9XCJvcGVuRmlsZSgpXCI+XG4gIDxhICpuZ0lmPVwiZmlsZS5maWxlVHlwZSA9PT0gJ0lNQUdFJ1wiPlxuICAgIDxpbWcgW2F0dHIuc3JjXT1cImZpbGUucGF0aFwiPlxuICA8L2E+XG4gIDx2aWRlbyBjb250cm9scz1cImNvbnRyb2xzXCIgcHJlbG9hZD1cIm1ldGFkYXRhXCIgKm5nSWY9XCJmaWxlLmZpbGVUeXBlID09PSAnVklERU8nXCI+XG4gICAgPHNvdXJjZSBzcmM9XCJ7e2ZpbGUudXJsIHx8IGZpbGUucGF0aH19I3Q9MC41XCIgYWx0PVwiXCIgdHlwZT1cInZpZGVvL21wNFwiIC8+XG4gIDwvdmlkZW8+XG48L2Rpdj5cbiIsIjx0eC1kaXNwbGF5PjwvdHgtZGlzcGxheT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O29CQ0NFO01BQUEsd0VBQXFDO2FBQUEsK0JBQ25DO01BQUE7TUFBQSxnQkFBNEI7OztJQUF2QjtJQUFMLFdBQUssU0FBTDs7OztvQkFFRjtNQUFBO01BQUEsOEJBQWdGO01BQzlFO1VBQUE7TUFBd0U7O0lBQWhFO1FBQUE7SUFBUixXQUFRLFNBQVI7Ozs7b0JBTEo7TUFBQTtRQUFBO1FBQUE7UUFBSztVQUFBO1VBQUE7UUFBQTtRQUFMO01BQUEsZ0NBQTBCO01BQ3hCO2FBQUE7VUFBQSxpQ0FFSTtNQUNKO2FBQUE7VUFBQSxpQ0FFUTtNQUNKOztJQU5EO0lBQUgsV0FBRyxTQUFIO0lBRzhDO0lBQTlDLFdBQThDLFNBQTlDOzs7O29CQ0pGO01BQUE7bUNBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/$$_gendir/app/shared/component/tx-display/tx-display.component.ngfactory.ts